import { render, staticRenderFns } from "./ConversationFooter.vue?vue&type=template&id=18d1bf75"
import script from "./ConversationFooter.vue?vue&type=script&lang=js"
export * from "./ConversationFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports